import { useTheme } from "@mui/material/styles";
import React from "react";
import { useTranslation } from "react-i18next";
import { ClockIcon } from "../../../../assets/icons";
import { AlertLineReportSummaryDTO } from "../../../../models/alert-line-report-summary/alert-line-report-summary-dto";
import CircleAndIconContainer from "../../reusable-widget-link-components/CircleAndIconContainer/CircleAndIconContainer";
const PendingAlertLineLink = ({
  customSummary,
  loading,
}: {
  customSummary: AlertLineReportSummaryDTO;
  loading: boolean;
}) => {
  const tRP = "components.custom_widget_links.manage_alert_lines.pending";
  const { t } = useTranslation();
  const theme = useTheme();
  return (
    <CircleAndIconContainer
      mainInfo={customSummary?.pending?.toString() ?? "0"} //pending
      description={`${t(`${tRP}`)}`}
      Icon={ClockIcon}
      IconStyle={{
        color: theme.palette.error.main,
        width: "90%",
        height: "90%",
      }}
      loading={loading} // add title
    />
  );
};
export default PendingAlertLineLink;
